import { FC } from 'react';
import Image from 'next/image';
import { Button } from '../../buttons';
import styles from './NewBankDetails.module.css';

interface NewBankDetailsProps {
  onClose: () => void;
  name?: string;
}

export const NewBankDetails: FC<NewBankDetailsProps> = ({ onClose }) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        New Bank Details <br /> for Buy Crypto / AUD Deposit
      </div>

      <div className={styles.description}>
        We&apos;ve updated the bank details for sending AUD to RelayPay when buying crypto.
      </div>

      <div className={styles.description}>
        You&apos;ll see the new BSB & Account numbers when making a crypto purchase using Bank Transfer. PayID remains
        unchanged.
      </div>

      <div className={styles.description}>
        Please delete RelayPay’s old account details from your saved list at your bank.
      </div>

      <div className={styles.imageContainer}>
        <Image src="/assets/BankTransferRP.png" alt="Transfer" className={styles.image} fill />
      </div>

      <Button fluid onPress={onClose} className={styles.button}>
        I understand
      </Button>
    </div>
  );
};
